/** Bouton résultat dépassement (étoiles animées) — inspiré Uiverse, adapté MultiRX. */

const STAR_PATH =
  'M392.05 0c-20.9,210.08 -184.06,378.41 -392.05,407.78 207.96,29.37 371.12,197.68 392.05,407.74 20.93,-210.06 184.09,-378.37 392.05,-407.74 -207.98,-29.38 -371.16,-197.69 -392.06,-407.78z';

function starSvg(): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 784.11 815.53" aria-hidden="true" focusable="false"><path class="overtake-result-star-path" d="${STAR_PATH}"/></svg>`;
}

const STAR_SLOTS = [
  { className: 'overtake-result-star-1', width: '25px' },
  { className: 'overtake-result-star-2', width: '15px' },
  { className: 'overtake-result-star-3', width: '5px' },
  { className: 'overtake-result-star-4', width: '8px' },
  { className: 'overtake-result-star-5', width: '15px' },
  { className: 'overtake-result-star-6', width: '5px' },
] as const;

export interface OvertakeResultButton {
  wrap: HTMLDivElement;
  button: HTMLButtonElement;
  label: HTMLSpanElement;
}

export function createOvertakeResultButton(onClick: () => void): OvertakeResultButton {
  const wrap = document.createElement('div');
  wrap.className = 'overtake-result-btn-wrap';

  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'overtake-result-btn is-pending';
  button.disabled = true;
  button.setAttribute('aria-label', 'Résultat du dépassement en cours');

  const label = document.createElement('span');
  label.className = 'overtake-result-btn-label';
  label.textContent = 'Résultat en cours…';

  for (const slot of STAR_SLOTS) {
    const star = document.createElement('div');
    star.className = `overtake-result-star ${slot.className}`;
    star.style.width = slot.width;
    star.innerHTML = starSvg();
    button.append(star);
  }

  button.append(label);
  button.addEventListener('click', onClick);
  wrap.append(button);

  return { wrap, button, label };
}

export function resetOvertakeResultButton(ui: OvertakeResultButton): void {
  ui.button.disabled = true;
  ui.button.className = 'overtake-result-btn is-pending';
  ui.label.textContent = 'Résultat en cours…';
  ui.button.setAttribute('aria-label', 'Résultat du dépassement en cours');
}

export function revealOvertakeResultButton(ui: OvertakeResultButton, success: boolean): void {
  ui.button.disabled = false;
  ui.button.classList.remove('is-pending', 'is-success', 'is-failure', 'is-revealed');

  if (success) {
    ui.button.classList.add('is-success');
    ui.label.textContent = 'Dépassement réussi !';
    ui.button.setAttribute('aria-label', 'Dépassement réussi — continuer');
    requestAnimationFrame(() => {
      ui.button.classList.add('is-revealed');
    });
  } else {
    ui.button.classList.add('is-failure');
    ui.label.textContent = 'Dépassement échoué';
    ui.button.setAttribute('aria-label', 'Dépassement échoué — continuer');
  }

  ui.button.focus({ preventScroll: true });
}
